export default __webpack_public_path__ + "static/media/figure_contact.a0451afb.png";